module.exports = __webpack_public_path__ + "img/corkboard-m.5f82f38a.svg";